import { store } from "../../store";
import AppRenderer from "../app_renderer";
import Debugger from "../console/debugger";
import { settingStore } from "../store/settingStore";
import { TOOLS } from "./tools";
import BookData from '../book_data';
export default class SettingTool {
    _pageTags = null;
    _setting = null;
    _toolBar = null;
    _confirmDialog = null;
    constructor(pageTags, setting, toolBar, confirmDialog) {
        this._pageTags = pageTags;
        this._setting = setting;
        this._toolBar = toolBar;
        this._confirmDialog = confirmDialog;
    }

    getToolFunction() {
        return [
            {
                key: "setting",
                event: this.openSetting()
            },
            {
                key: "display_type",
                event: this.switchDisplayType()
            },
            {
                key: "pen_click",
                event: this.enablePenClick()
            },
            {
                key: "custom_cursor",
                event: () => { }
            },
            {
                key: "page_tag",
                event: this.enablePageTags()
            },
            {
                key: "update",
                event: this.openUpdateExe()
            },
            {
                key: "default_tool",
                event: this.resetToolBar()
            }
        ]
    }

    enablePageTags() {
        Debugger.Instance.log("page tags", "setting_tool");
        const self = this;
        return () => {
            // store.setSinglePageMode(!store.singlePageMode);
            self._pageTags.toggle();
        }
    }

    openSetting() {
        Debugger.Instance.log("setting", "setting_tool");
        const self = this;
        return () => {
            self._setting.show = true;
        }
    }

    enablePenClick() {
        Debugger.Instance.log("isPenClick", "setting_tool");
        return () => {
            settingStore.isPenClick = (settingStore.isPenClick) ? 0 : 1;
        }
    }

    openUpdateExe() {
        Debugger.Instance.log("update", "setting_tool");
        return () => {
            console.log("update, ",);
            this._confirmDialog.showDialog(
                "檢查更新",
                "電子書即將關閉，請先確認您已存檔",
                () => {
                    AppRenderer.Instance.openFile(BookData.Instance.AppPath + "/檢查更新.exe", true);
                    // AppRenderer.Instance.exit();
                },
                null,
                "確認關閉"
            );
        }
    }

    switchDisplayType() {
        return () => {
            settingStore.isFixed = 1 - settingStore.isFixed;
        }
    }

    resetToolBar() {
        const self = this;
        return () => {
            self._toolBar.setToolsToDefault();
        }
    }
}